import { TypographyP } from '@talentmesh/ui/components/typography';
import { CheckboxRowProps } from '@/Pages/Candidates/Overview/Components/Filter/CheckboxRow';
import ListVirtualization from '@/Pages/Candidates/Overview/Components/Filter/ListVirtualization';

interface MenuListItemGroupProps {
    label: string;
    items: CheckboxRowProps[];
}

const MenuListItemGroup = ({ label, items }: MenuListItemGroupProps) => {
    const rowHeight = 42;

    const calculateContainerHeight = (menuItemsCount: number): number => {
        const maxVisibleRows = 4;
        const calculatedVisibleRows = menuItemsCount < maxVisibleRows ? menuItemsCount : maxVisibleRows;

        return rowHeight * calculatedVisibleRows + rowHeight / 2;
    };

    return (
        <div className="flex flex-col" data-cy="MenuListItemGroup">
            <TypographyP className="px-4 py-2">{label}</TypographyP>
            <ListVirtualization
                items={items}
                containerHeight={calculateContainerHeight(items.length)}
                itemHeight={rowHeight}
            />
        </div>
    );
};

export default MenuListItemGroup;
